import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AwayAdActionsPage } from './away-ad-actions.page';

const routes: Routes = [
  {
    path: '',
    component: AwayAdActionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AwayAdActionsPageRoutingModule {}
